import * as ReactHelmetAsync from 'react-helmet-async';
const Helmet = ReactHelmetAsync.Helmet || (ReactHelmetAsync as any).default?.Helmet;
import { Link } from 'react-router-dom';
import { Navigation } from '@/components/layout/Navigation';
import { Footer } from '@/components/layout/Footer';
import { PageHero } from '@/components/sections/PageHero';

export function FlightReview() {
  return (
    <>
      <Helmet>
        <title>Flight Review | Total Tailwheel</title>
        <meta
          name="description"
          content="Complete your flight review in a tailwheel airplane. A fun alternative to the same old laps in a 172. Located at Minute Man Air Field in Stow, MA, near Boston."
        />
        <link rel="canonical" href="https://totaltailwheel.com/training/flight-review" />
      </Helmet>

      <div className="min-h-screen bg-gray-50">
        <Navigation />
        <PageHero title="Flight Review" />

        <section className="py-16">
          <div className="container mx-auto px-4">
            <div className="max-w-3xl mx-auto">
              <div className="bg-white p-8 rounded-lg shadow-md">
                <p className="text-foreground/80 mb-4">
                  Your{' '}
                  <a
                    href="https://www.ecfr.gov/current/title-14/chapter-I/subchapter-D/part-61/subpart-A/section-61.56"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-primary underline hover:text-primary/80"
                  >
                    FAR 61.56
                  </a>{' '}
                  flight review doesn't have to be the same old laps around the pattern in a 172 or Cherokee. Do it
                  in a tailwheel airplane instead — it's more fun, more challenging, and you'll build tailwheel
                  time while staying current.
                </p>

                <p className="text-foreground/80 mb-6">
                  A flight review includes a minimum of 1 hour of ground instruction and 1 hour of flight, covering
                  regulations, airspace, and flight maneuvers. We'll make it a worthwhile experience, not just
                  a box to check.
                </p>

                <div className="bg-primary/5 border border-primary/20 rounded-lg p-4 mb-6">
                  <p className="text-sm text-foreground/70">
                    Located at <strong>Minute Man Air Field (6B6)</strong> in Stow, MA — just 30 minutes west of Boston,
                    with easy access from Route 2 and Route 495.
                  </p>
                </div>

                <div className="text-center">
                  <Link
                    to="/inquire"
                    className="inline-block bg-primary text-white px-6 py-3 rounded-lg hover:bg-primary/90 transition-colors font-medium"
                  >
                    Inquire Now
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
}
